import React from 'react';
import { IGridSettings, IImageData, IImageSettings, Image } from '@msdyn365-commerce/core';


export const renderBaseImage = (
    gridSettings?: IGridSettings,
    PrimaryImageUrl?: string,
    altText?: string,
    fallbackImageUrl?: any,
    lazyLoading?: boolean
): JSX.Element | null => {
    if (!PrimaryImageUrl || !gridSettings) {
        return null;
    }
    const defaultImageSettings: IImageSettings = {
        viewports: {
            xs: { q: `w=240&h=240&m=6`, w: 0, h: 0 },
            lg: { q: `w=240&h=240&m=6`, w: 0, h: 0 },
            xl: { q: `w=240&h=240&m=6`, w: 0, h: 0 }
        },
        lazyload: lazyLoading ? lazyLoading : false
    };

    const img: IImageData = {
        src: PrimaryImageUrl ? PrimaryImageUrl : '',
        altText: altText ? altText : ''
    };
    return (
        <Image
            {...img}
            gridSettings={gridSettings}
            fallBackSrc={fallbackImageUrl}
            imageSettings={defaultImageSettings}
            bypassHideOnFailure={true}
            imageFallbackOptimize={true}
        />
    );
};